import { render, staticRenderFns } from "./StatementChartController.vue?vue&type=template&id=1031d590&"
import script from "./StatementChartController.vue?vue&type=script&lang=ts&"
export * from "./StatementChartController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports